import component from './styled';

export default component;
